export default {
  TipoOperacao: [
    {
      value: 1,
      text: 'Inclusão',
      color: 'teal--text teal apply-opacity',
      borderColor: '#009688'
    },
    {
      value: 2,
      text: 'Alteração',
      color: 'warning--text warning apply-opacity',
      borderColor: 'var(--v-warning-base)'
    },
    {
      value: 3,
      text: 'Exclusão',
      color: 'danger--text danger apply-opacity',
      borderColor: 'var(--v-danger-base)'
    }
  ],

  // Adicione outras constantes de array que sejam utilizadas no sistema
  StatusOperacao: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Recusado' }
  ],

  // Métodos auxiliares podem ser incluídos aqui
  getTipoOperacao(value) {
    return this.TipoOperacao.find(item => item.value === value) || {};
  }
};